// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3TgfK","loaderOuter":"PageOverlayLoader_loaderOuter__11vM_"};